var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 1.66665C2.45666 1.66665 2.2553 1.75005 2.10683 1.89852C1.95837 2.04699 1.87496 2.24835 1.87496 2.45831V13.5416C1.87496 13.7516 1.95837 13.953 2.10683 14.1014C2.2553 14.2499 2.45666 14.3333 2.66663 14.3333H15.3333C15.5433 14.3333 15.7446 14.2499 15.8931 14.1014C16.0416 13.953 16.125 13.7516 16.125 13.5416V4.83331C16.125 4.62335 16.0416 4.42199 15.8931 4.27352C15.7446 4.12505 15.5433 4.04165 15.3333 4.04165H8.20829C7.9436 4.04165 7.69641 3.90936 7.54959 3.68912L6.20127 1.66665H2.66663ZM0.987247 0.778934C1.43265 0.333535 2.03674 0.083313 2.66663 0.083313H6.62496C6.88966 0.083313 7.13684 0.215601 7.28367 0.435842L8.63198 2.45831H15.3333C15.9632 2.45831 16.5673 2.70854 17.0127 3.15393C17.4581 3.59933 17.7083 4.20342 17.7083 4.83331V13.5416C17.7083 14.1715 17.4581 14.7756 17.0127 15.221C16.5673 15.6664 15.9632 15.9166 15.3333 15.9166H2.66663C2.03674 15.9166 1.43265 15.6664 0.987247 15.221C0.541848 14.7756 0.291626 14.1715 0.291626 13.5416V2.45831C0.291626 1.82842 0.541848 1.22433 0.987247 0.778934Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcEmpty);
export default __webpack_public_path__ + "static/media/folder_ic_empty.6f7ebd2ba31e8418995f9aad88d8c134.svg";
export { ForwardRef as ReactComponent };